const configuredApiBaseUrl = import.meta.env.VITE_API_BASE_URL?.trim();
const API_BASE_URL = (configuredApiBaseUrl || '/api').replace(/\/$/, '');

/**
 * Best-effort report to POST /api/client-errors, which is deliberately unauthenticated (see
 * server SecurityConfig) so failures that happen before the browser holds a token - like a
 * failed sign-in - can still reach the server's logs. Never throws: a reporting failure must
 * not affect the user-facing flow that triggered it.
 */
export function reportClientError(category: string, message: string): void {
  void fetch(`${API_BASE_URL}/client-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ category, message, url: window.location.href, userAgent: navigator.userAgent })
  }).catch(() => {});
}
